package ui.campaign.detailv2.editor.widget

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import api.DayOfWeek

@Composable
fun rememberCampaignDaysAsString(days: Int): String {
    return remember(days) {
        DayOfWeek.all
            .filter { it match days }
            .takeIf { it.isNotEmpty() }
            ?.joinToString { it.label }
            ?: "NONE"
    }
}